import Bowser from "bowser";
import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

type DeviceSizeType = "desktop" | "tablet" | "mobile";

type DeviceContextType = {
  browser: Bowser.Parser.ParsedResult;
  width: number;
  height: number;
  deviceSize: DeviceSizeType;
  isTouch: boolean;
};

const DeviceContext = createContext<DeviceContextType>({} as DeviceContextType);

export const DeviceProvider: FC<PropsWithChildren> = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const func = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", func);

    return () => window.removeEventListener("resize", func);
  }, []);


  const browser = useMemo(() => Bowser.parse(window.navigator.userAgent), []);

  const isTouch = useMemo(() => {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      // @ts-ignore
      navigator.msMaxTouchPoints > 0
    );
  }, []);
  const ctxValue = useMemo(
    () => ({
      width,
      isTouch,
      height,
      browser,
      deviceSize: ((): DeviceSizeType => {
        if (width <= 750) return "mobile";
        if (width <= 1024) return "tablet";

        return "desktop";
      })(),
    }),
    [width, isTouch, height, browser],
  );

  return (
    <DeviceContext.Provider value={ctxValue}>{children}</DeviceContext.Provider>
  );
};

export const useDevice = () => useContext(DeviceContext);
